import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
import _imports_0 from '../assets/benefits.png';
const _hoisted_1 = {
    key: 0,
    class: "simplePage",
    style: { "margin-top": "-40px" }
};
const _hoisted_2 = { class: "anchor-bottom" };
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useQuizApi } from '@/composables/useQuizApi';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'BenefitsCalculatorLandingPage',
    setup(__props) {
        const router = useRouter();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getQuestionnaireByKey } = useQuizApi();
        function startSurvey() {
            getQuestionnaireByKey('InBest', (q) => {
                console.log(q, 'Found this questionnaire');
                router.replace({ path: '/Questionnaire/' + q.id, query: { theme: 'dark', allowBack: 'true', allowSkip: 'false', escapeRoute: 'you' } });
            });
        }
        onMounted(() => {
            getCustomer();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    bgcolor: "#00000000",
                    border: "0"
                }),
                (!_ctx.about)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _cache[0] || (_cache[0] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
                        _cache[1] || (_cache[1] = _createElementVNode("h1", null, "You may be entitled to benefits", -1)),
                        _cache[2] || (_cache[2] = _createElementVNode("p", null, "Based on your circumstances, we believe you may be entitled to some support. Our calculator could help you access unclaimed benefits, maximise your income and reduce your bills. ", -1)),
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(MGButton, {
                                text: "Find out more",
                                arrow: "",
                                onClick: startSurvey
                            })
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
